import * as React from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';


const HubspotUpdateSuccessDialog = () => {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"WELCOME!"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          <span>Thank you for signing up with <span style={{"color": "#247bff", "fontWeight": "bold"}}>Better Refunds</span>. We will begin working on your reimbursements, and you should start seeing results shortly.</span>
          <br></br><br></br><span>Feel free <a target='blank' href='https://meetings-eu1.hubspot.com/meetings/david-schenkler-better-refunds/maximizing-your-fba-reimbursements' style={{"textDecoration": "none", "color": "#247bff"}}>to contact us</a> at anytime.</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
          {/* <Button onClick={createAwsStateAndNavigateToAws} autoFocus>
            Authorize
          </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default HubspotUpdateSuccessDialog;